export default "__VITE_ASSET__C$BMz_QE__"